import { createReducer, on } from '@ngrx/store';
import { BrainEstreamComputeResponse } from 'brain-data/model/brain-estream-compute.model';
import {
  estreamComputeCacheKey,
  loadEstreamCompute,
  loadEstreamComputeError,
  loadEstreamComputeSuccess,
} from '../actions/estream-compute.action';

export default interface EstreamComputeState {
  responsesByKey: { [key: string]: BrainEstreamComputeResponse };
  loadingByKey: { [key: string]: boolean };
  errorByKey: { [key: string]: Error };
}

export const initialState: EstreamComputeState = {
  responsesByKey: {},
  loadingByKey: {},
  errorByKey: {},
};

export const reducer = createReducer(
  initialState,
  on(loadEstreamCompute, (state, { request }): EstreamComputeState => ({
    ...state,
    loadingByKey: { ...state.loadingByKey, [estreamComputeCacheKey(request)]: true },
  })),
  on(loadEstreamComputeSuccess, (state, { request, response }): EstreamComputeState => {
    const key = estreamComputeCacheKey(request);
    const nextLoading = { ...state.loadingByKey };
    delete nextLoading[key];
    return {
      ...state,
      responsesByKey: { ...state.responsesByKey, [key]: response },
      loadingByKey: nextLoading,
    };
  }),
  on(loadEstreamComputeError, (state, { request, error }): EstreamComputeState => {
    const key = estreamComputeCacheKey(request);
    const nextLoading = { ...state.loadingByKey };
    delete nextLoading[key];
    return {
      ...state,
      loadingByKey: nextLoading,
      errorByKey: { ...state.errorByKey, [key]: error },
    };
  }),
);
